module.exports = {
    "r01": "El",
    "r02": "Eld",
    "r03": "Tir",
    "r04": "Nef",
    "r05": "Eth",
    "r06": "Ith",
    "r07": "Tal",
    "r08": "Ral",
    "r09": "Ort",
    "r10": "Thul",
    "r11": "Amn",
    "r12": "Sol",
    "r13": "Shael",
    "r14": "Dol",
    "r15": "Hel",
    "r16": "Io",
    "r17": "Lum",
    "r18": "Ko",
    "r19": "Fal",
    "r20": "Lem",
    "r21": "Pul",
    "r22": "Um",
    "r23": "Mal",
    "r24": "Ist",
    "r25": "Gul",
    "r26": "Vex",
    "r27": "Ohm",
    "r28": "Lo",
    "r29": "Sur",
    "r30": "Ber",
    "r31": "Jah",
    "r32": "Cham",
    "r33": "Zod"
};



// WEBPACK FOOTER //
// ./src/components/character/item/rune-names.js